/* Publish by EComposer at 2026-10-21 20:54:39*/
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-vchxxyk37wo"]=  window.__ectimmers["ecom-vchxxyk37wo"] || {};
if(!this.$el)return;const t=this.$el,e=t.querySelector(".ecom-text_view-more-btn"),i=t.querySelector(".ecom-text_view-less-btn"),s=t.querySelector(".text-content.ecom-html");!s||(e&&e.addEventListener("click",()=>{s.classList.remove("ecom-text--is-mark"),s.style.maxHeight="",e.style.display="none",i.style.display=""}),i&&i.addEventListener("click",()=>{s.classList.add("ecom-text--is-mark"),s.style.maxHeight="var(--ecom-text-height)",i.style.display="none",e.style.display=""}))

                    });
                    
                        document.querySelectorAll('.ecom-vchxxyk37wo').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-vchxxyk37wo', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-wpa6ehl7c1').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-wpa6ehl7c1', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-pnl9c0jz03j').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-pnl9c0jz03j', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ut0m2gy1di').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ut0m2gy1di', settings: {},isLive: true});
                        });
                    

                })();
            
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-hshcdwxn82w"]=  window.__ectimmers["ecom-hshcdwxn82w"] || {};
const t=function(r){if(window.EComModal)return r();if(window.EComposer&&typeof window.EComposer.loadVendor=="function"){window.EComposer.loadVendor("modal_js").then(function(){window.EComModal&&r()});return}let a=0;const l= window.__ectimmers["ecom-hshcdwxn82w"]["0s0feiw63"] = setInterval(function(){window.EComModal?(clearInterval(l),r()):++a>=300&&clearInterval(l)},50)};if(this.settings.link==="lightbox"&&this.settings.lightbox==="yes"&&this.$el){var e=this.$el.querySelector("[ecom-modal]"),i=this.id;t(function(){new window.EComModal(e,{cssClass:["ecom-container-lightbox-"+i]})})}let s=this.$el;if(!s)return;function o(r){const a=r.getBoundingClientRect();return a.top>=0&&a.left>=0&&a.bottom-r.offsetHeight/2<=(window.innerHeight||document.documentElement.clientHeight)&&a.right<=(window.innerWidth||document.documentElement.clientWidth)}function n(){let r=s.querySelector(".ecom-element.ecom-base-image"),a=s.closest(".core__row--columns");r&&(o(r)?(r.classList.add("image-highlight"),a.setAttribute("style","z-index: unset")):(r.classList.remove("image-highlight"),a.setAttribute("style","z-index: 1")))}this.settings.highligh_on_viewport&&window.addEventListener("scroll",function(){n()})

                    });
                    
                        document.querySelectorAll('.ecom-hshcdwxn82w').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-hshcdwxn82w', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-6jmcr6lqt8n').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-6jmcr6lqt8n', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-df96un16nme').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-df96un16nme', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-9ddu745lua').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-9ddu745lua', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    

                })();
            
;try{
 
} catch(error){console.error(error);}